/**
 * Fixes for odd behavior with Parsley classes on SlimSelect elements
 */

export default class SlimParsleyIntegration {
    constructor() {
        this.initListeners();
    }

    initListeners() {
        // Manually call Parsley validate method when a SlimSelect element changes
        $('.slim-select[required]').on('change', (event) => {
            const $element = $(event.currentTarget);
            $element.parsley().validate();
        });

        // Manually toggle parsley error/success classes for SlimSelect fields
        // Parsley and SlimSelect seem to fight over manipulating the parent element
        // when left to their own devices
        window.Parsley.on('field:error', (event) => {
            const { $element } = event;
            if ($element.is('.slim-select[data-ssid]')) {
                $element.addClass('parsley-error').removeClass('parsley-success');
            }
        });

        window.Parsley.on('field:success', (event) => {
            const { $element } = event;
            if ($element.is('.slim-select[data-ssid]')) {
                $element.addClass('parsley-success').removeClass('parsley-error');
            }
        });
    }
}
